<template>
  <div class="end-date-time">
    <div
      class="input-wrapper awsome-wrapper starts-appoitment all-day-wrapper timing-wrapper show-awsome-select main-content"
    >
      <div class="title-wrapper position-relative">
        <span class="ver-center">End Time</span>
      </div>
      <div class="content-wrapper position-relative">
        <div
          class="date-wrapper ver-center show-awsome-select calendar-wrapper text-right r-10 toggle-calendar full-width"
        >
          <input
            type="time"
            name="start-time"
            class="text-only-input ml-10"
            :value="formattedTime"
            @change="setTimeLocal"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { dateAndTimeMixin } from "../../../../mixins/dateAndTimeMixin";

export default {
  mixins: [dateAndTimeMixin],
  computed: {
    ...mapGetters({
      time: "getEndTime" // Get the end repeat time
    }),
    formattedTime() {
      return this.formatTime24(this.time.hr, this.time.min);
    }
  },
  methods: {
    ...mapMutations({
      setTime: "setEndTime" // Function to set the end time
    }),
    /**
     * When time is changed, change the time in global state
     */
    setTimeLocal(event) {
      const time = event.target.value.split(":");
      this.setTime({ hr: parseInt(time[0]), min: parseInt(time[1]), sec: 0 });
    }
  }
};
</script>

<style scoped></style>
